// @flow

import * as React from 'react';

import type { Actions } from '../../../types';
import Row from '../../../components/Row';
import ActionsColumn from '../../../components/ActionsHeaderColumn';
import Separator from '../../../components/Separator';
import ItemFullHistoryAction from '../../../components/actions/ItemFullHistoryAction';
import ClearFiltersAction from '../../../components/actions/ClearFiltersAction'
import { DesktopView, MobileView } from '../../../config/mediaQuery';

type Props = {
  minHeight: string,
  displayRowMenu: Boolean,
};

const ActionsOrganizerAccounts = (props: Actions & Props) => {
  const {
    ColumnsAction,
    CopyAction,
    ExportAction,
    RefreshAction,
    MultiSortAction,
    SaveViewAction,
    currentItem,
    getGlobalDisabledState,
    isOneRowSelected,
    loading,
    clearInternalFilters,
    displayRowMenu,
    displayMenu
  } = props;

  const copyAction = <CopyAction />;
  const fullItemHistory = <ItemFullHistoryAction
    disabled={getGlobalDisabledState() || !isOneRowSelected || loading}
    item={currentItem}
  />;

  return (
    <>
      <DesktopView>
        <Row minHeight={props.minHeight}>
          <ActionsColumn>
            <RefreshAction />
            <ExportAction />
          </ActionsColumn>

          <ActionsColumn>
            {copyAction}
            <ColumnsAction />
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            <SaveViewAction />
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            {fullItemHistory}
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            <ClearFiltersAction clearInternalFilters={clearInternalFilters} disabled={loading} />
          </ActionsColumn>

          <ActionsColumn>
            <MultiSortAction />
          </ActionsColumn>
        </Row>
      </DesktopView>
      <MobileView>
        {displayRowMenu &&
          <div className='actions-menu-top-section'>
            <div style={{ fontWeight: 'bold', color: 'black' }}>{currentItem && currentItem.Description}</div>
          </div>
        }
        <div className='action-menu-items'>
          <ActionsColumn>
            <table>
              {displayMenu &&
                <tbody>
                  <tr>
                    <td><ExportAction /></td>
                  </tr>
                  <tr>
                    <td><SaveViewAction /></td>
                  </tr>
                </tbody>
              }
              {displayRowMenu &&
                <tbody>
                  <tr>
                    <td>{fullItemHistory}</td>
                  </tr>
                  <tr>
                    <td><CopyAction /></td>
                  </tr>
                </tbody>
              }
            </table>
          </ActionsColumn>
        </div>
      </MobileView>
    </>
  );
};

export default ActionsOrganizerAccounts;
